const viewMoreButtons = document.querySelectorAll(
	'.block-bruckmann-specifications__view-more-button'
);

const toggleViewMoreContentClass = (e) => {
	e.preventDefault();

	const currentItem = e.currentTarget.closest(
		'.block-bruckmann-specifications'
	);

	if (!currentItem) {
		return;
	}

	const currentContent = currentItem.querySelector(
		'.block-bruckmann-specifications__view-more-content'
	);

	if (currentContent) {
		currentContent.classList.toggle('is-open');
	}
};

if (viewMoreButtons.length) {
	viewMoreButtons.forEach((viewMoreButton) => {
		viewMoreButton.addEventListener('click', toggleViewMoreContentClass);
	});
}
